module.exports = __webpack_public_path__ + "img/img_051@2x.bdffe51e.png";